import React, {Component} from "react";
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import img1 from "../../../../../assets/img/kitcut-footer--pages-images/page4-1.png";


class Page4 extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <div className="faq-page-layout">
                <div className="beginners-background-div footer-nav-pages-background">

                    <h3 className='font-size-30 yu-gothic-bold '>
                        推奨されるGERBER DATAのファイル名
                    </h3>

                    <p className='all-content-font-size'>
                        推奨されるファイル名
                    </p>
                    <div className="row">
                    <img className="img-size-footer-nav-page4" src={img1} alt=""/>
                    </div>
                    <p className='all-content-font-size'>
                        Windowsシステムがファイル拡張子を隠している場合がありますので、このWindowsガイドに従って、拡張子を表示させてください。
                        <br/>
                        <a href="https://support.microsoft.com/ja-jp/hub/4338813/windows-help?os=windows-7#show-hide-file-name-extensions=windows-7" target='_blank'
                        >
                            ファイル名拡張子の表示/非表示</a>

                    </p>
                    <p className='all-content-font-size'>
                        私たちのシステムは大文字と小文字を区別しません。
                        <br/>
                        大文字と小文字の組み合わせは、すべてのファイル名と拡張子に対して有効です。

                    </p>


                    <p className='all-content-font-size'>
                        <b>ファイル名関連の問題</b><br/>
                        最も一般的な問題は、ボードアウトラインです。
                        <br/>
                        通常、エラーは次のカテゴリに分類されます。
                    </p>


                    <p className='all-content-font-size'>
                        <b>アウトラインは0.25 “✕0.25”より大きくしてください</b><br/>
                        これは、zipファイルに複数の
                        “ボードアウトライン”にファイル名が含まれている場合によく発生します。
                        <br/>
                        通常、これは「GKO」、「GM1」、および「GM2」ファイルが存在するときに発生します。
                        <br/>
                        余分なファイルを削除してください。

                    </p>

                    <p className='all-content-font-size'>
                        <b> ボードアウトラインファイルが見つかりません</b><br/>
                        ボードアウトラインが見つからないか、ファイル名が検出されませんでした。
                        <br/>
                        アウトラインファイルがある場合は、「拡張子を「.GKO」に変更してに変更をお願いします。
                        <br/>
                        システムに検出させます。
                        <br/>
                        ファイルが存在しない場合は、予測される形式でファイルを生成します。

                    </p>


                    <p className='all-content-font-size'>
                        <b> 片面基板の場合、以下の問題がよく発生します。</b><br/>
                        <ul>
                            <li> ドリルファイルが見つかりませんでした。
                            </li>
                            <li> マスクレイヤが見つかりませんでした。
                            </li>
                            <li> 銅層が見つかりませんでした
                            </li>
                        </ul>

                    </p>

                    <p className='all-content-font-size'>
                        私たちのシステムのエラーチェックは両面基板（2層）のガーバーファイルを対象としているので、
                    </p>
                    <p className='all-content-font-size'>  トップとボトムの両方のマスク層とドリルヒットが必要です。
                    </p>
                    <p className='all-content-font-size'> ほとんどの設計CADにとって簡単な解決策は、単にボードアウトライン層の外側に露出ビアを追加することです。
                    </p>
                    <p className='all-content-font-size'> ボードスタックアップが両面基板（2層）用に設定されている場合は、必要なすべてのレイヤーが生成され、
                    </p>
                    <p className='all-content-font-size'>
                        デザインに影響を与えることなくパネル化の前にトリミングされます。
                    </p>
                    <p className='all-content-font-size'>
                        4層基板の場合は、サイトに「Detected 4 layer board」と表示されていることを確認します。
                    </p>
                    <p className='all-content-font-size'>
                        私たちのサイトが内部レイヤを検出していない場合は、正しい順序でレイヤを確認するために、4レイヤスタックアップを参照下さい。
                    </p>


                </div>
            </div>
        );
    }
}

export default Page4;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/FooterNavPages/page4.js